import React from "react";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popovers from "react-bootstrap/Popover";
import Modal from "react-bootstrap/Modal";
import userRoles from "../helpers/role";
import { FaToolbox } from "react-icons/fa";
import { MdReport } from "react-icons/md";
import { getMMPLShipInfo } from "../Actions/MMPLDashboardAPI";
import {
  downloadServiceRequest,
  downloadShipEquipmentStatus,
} from "../Actions/ShipEquipmentDetailsAPI";
import { Button, Popover, PopoverHeader, PopoverBody } from "reactstrap";
import moment from "moment";
import $ from "jquery";
import note from "../Asset/note_svg.svg";
import { left } from "glamor";
import i18n from "./DropdownLanguage/i18n";

let user = localStorage.getItem("UserRoles");

class MMPLShipCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
      rows: 10,
      first2: 0,
      rows2: 10,
      modalIsOpen: false,
      RemarkmodalIsOpen: false,
      Records: [],
      EditAll: false,
      isShip: false,
      isShore: false,
      isBoth: false,
      isMobile: false,
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  resize() {
    if (window.innerWidth > 1185) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
  }

  // componentDidMount() {
  //   console.log($("div#popup-trigger").data("item"), "Item");
  //   window.addEventListener('click', function (e) {
  //     console.log($(e.target).attr('id'))
  //     if (document.getElementById('popup-trigger').contains(e.target)) {
  //       alert("inside");
  //     } else {
  //       alert("Outside");
  //     }
  //   });
  // }

  renderPopover(props) {
    const { t } = this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>{t("content.DownloadStatus")}</label>
        </Popovers.Content>
      </Popovers>
    );
  }
  renderMoreDetails(props) {
    const { t } = this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>{t("content.MoreInformation")} </label>
        </Popovers.Content>
      </Popovers>
    );
  }
  renderViewDetails(props) {
    const { t } = this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>{t("PendingShipScreenContent.ViewShipDetails")} </label>
        </Popovers.Content>
      </Popovers>
    );
  }

  renderbudgetover(props) {
    const { t } = this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>{t("content.BudgetListScreen")}</label>
        </Popovers.Content>
      </Popovers>
    );
  }
  renderShipService(props) {
    const { t } = this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>
            {t("content.EquipmentServiceDetailsScreen")}
          </label>
        </Popovers.Content>
      </Popovers>
    );
  }
  renderShipNotes(props) {
    const { t } = this.props;
    return (
      <Popovers id="history-tooltip" {...props}>
        <Popovers.Content>
          <label style={{ padding: "0px 10px" }}>
            {t("content.Shipnotes")}
          </label>
        </Popovers.Content>
      </Popovers>
    );
  }

  render() {
    const { arraylist, pageSize, shipMMPLInfo, currentPage, totalRecords, MMPLShipInfo, t } =
      this.props;
    return (
      <div className="pb-3">
        <Modal
          size="md"
          show={this.state.modalIsOpen}
          onHide={() => this.setState({ modalIsOpen: false })}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-sm">
              {t("DashboardMoreInformation.MoreInformation")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table style={{ width: "100%" }}>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.ShipEmail")}</th>
                <td>{MMPLShipInfo ? MMPLShipInfo.shipEmail : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.ShipContactNumber1")}</th>
                <td>{MMPLShipInfo ? MMPLShipInfo.shipContactNumber1 : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.ShipContactNumber2")}</th>
                <td>{MMPLShipInfo ? MMPLShipInfo.shipContactNumber2 : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.SuperintendentEmail")}</th>
                <td>{MMPLShipInfo ? MMPLShipInfo.superintendentEmail : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.SuperintendentPhone")}</th>
                <td>{MMPLShipInfo ? MMPLShipInfo.superintendentPhone : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.FleetManagerEmail")}</th>
                <td>{MMPLShipInfo ? MMPLShipInfo.fleetManagerEmail : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.TechnicalExecutiveEmail")}</th>
                <td>
                  {MMPLShipInfo ? MMPLShipInfo.technicalExecutiveEmail : ""}
                </td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.VesselGroupEmail")}</th>
                <td>{MMPLShipInfo ? MMPLShipInfo.vesselGroupEmail : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.CompanyDetails")}</th>
                <td>{MMPLShipInfo ? MMPLShipInfo.companyDetails : ""}</td>
              </tr>
              <tr style={{ lineHeight: "30px" }}>
                <th>{t("DashboardMoreInformation.InvoiceForwardingEmail")}</th>
                <td>
                  {MMPLShipInfo ? MMPLShipInfo.invoiceForwardingEmail : ""}
                </td>
              </tr>
            </table>
          </Modal.Body>
        </Modal>
        <Modal
          size="lg"
          show={this.state.RemarkmodalIsOpen}
          onHide={() => this.setState({ RemarkmodalIsOpen: false })}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
        >
          <Modal.Header
            className="ClosebtnColor"
            closeButton
            style={{ backgroundColor: "rgb(26, 52, 100)", color: "white" }}
          >
            <Modal.Title id="example-modal-sizes-title-sm">
              {t("DashboardShipReports.ShipReports")}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table style={{ width: "100%" }}>
              {this.state.Records && this.state.Records.length != 0 ? (
                <tbody>
                  {this.state.Records?.map((item, index) => {
                    return (
                      <div>
                        <div className="row">
                          <div className="col7" style={{ paddingLeft: 15 }}>
                            {index + 1}.
                          </div>
                          <div className="col-sm-6">
                            <span>
                              <strong>{t("DashboardShipReports.Title")} : </strong>
                              <span> {item?.title} </span>
                            </span>
                          </div>
                          <div className="col-sm-5">
                            <span>
                              <strong>{t("DashboardShipReports.Date")} : </strong>
                              <span>
                                {item?.date
                                  ? moment(item.date).format("DD MMM YYYY")
                                  : ""}
                              </span>
                            </span>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12 paddingcard">
                            <span>
                              <strong>{t("DashboardShipReports.Remarks")} : </strong>{" "}
                            </span>
                          </div>
                          <div className="col-sm-12 paddingcard">
                            <span> {item?.remark} </span>
                          </div>
                        </div>
                        <br />
                      </div>
                    );
                  })}
                </tbody>
              ) : (
                <center>
                  <span> {t("CommonText.NoReport")}</span>
                </center>
              )}
            </table>
          </Modal.Body>
        </Modal>

        {this.renderCardData()}

        {arraylist.data.length != 0 ? (
          <div className="custom-paginator">
            <Paginator
              first={currentPage}
              rows={pageSize}
              totalRecords={totalRecords}
              onPageChange={(e) => this.onPaginatorChange(e)}
            ></Paginator>
          </div>
        ) : (
          <div
            className="card"
            style={{ overflow: "hidden", position: "relative" }}
          >
            <div className="container">
              <h6 className="resource-list-title no-item-card">
                {t("CommonText.NoItem")}
              </h6>
            </div>
          </div>
        )}
      </div>
    );
  }

  onPaginatorChange(event) {
    
    this.setState({
      first: event.first,
    }, () => { console.log(this.state.first) });
    const { setUpdatedState } = this.props;
    setUpdatedState(event.page + 1, 2);
  }
  getShipRemark(item) {
    this.setState({ RemarkmodalIsOpen: true, Records: item });
  }

  getShipMMPLInfo(item) {
    
    const { dispatch } = this.props;
    dispatch(getMMPLShipInfo(item));
    this.setState({ modalIsOpen: true });
  }

  toggle = (target, item) => {
    this.setState({
      [target]: !this.state[target],
      ship: false,
      shore: false,
      both: false,
    });
  };

  handleRadioButtonChange = (e) => {
    let nodeName = e.target.name;
    if (nodeName === "ship") {
      this.state.isShip = true;
      this.state.isShore = false;
      this.state.isBoth = false;
    }
    if (nodeName === "shore") {
      this.state.isShip = false;
      this.state.isShore = true;
      this.state.isBoth = false;
    }
    if (nodeName === "both") {
      this.state.isShip = false;
      this.state.isShore = false;
      this.state.isBoth = true;
    }
    this.setState({});
  };

  renderCardData = () => {
    const { showSidePane, arraylist, isServiceDetail, showMMPLDetailsPane, t, isContract, isBoth } =
      this.props;
    const isArabic = i18n.language === 'arab';
    // const isRTL = document.documentElement.getAttribute("dir") === "rtl";
    // console.log(isRTL,'RTL')
    return arraylist.data && arraylist.data.length
      ? arraylist.data.map((item, index) => {

        return (
          <div
            className="card mb-1"
            style={{ overflow: "hidden", position: "relative" }}
          >


            <div className="p-3">
              <div className="resource-list-auth-date">
                <div className="row">
                  <div className="col-sm-10 col-md-10 col-10 col-m-auto">
                    <div className="row px-3">
                      <div className="col-sm-4 col-lg-3 pb-1 ship-title-note-wrapper" style={{ display: 'flex', justifyContent: 'space-between', minHeight:'2em'}}>
                        <h6
                          className="resource-list-title m-0"
                          onClick={() => this.ShowSidePanel(item.shipId)}
                          // title={item.shipName}
                          // style={{
                          //   whiteSpace: 'nowrap',
                          //   overflow: 'hidden', 
                          //   textOverflow: 'ellipsis',
                          //   width: '100%',
                          // }}
                          style={{fontSize:'large'}}
                        >
                          {item.shipName !== "" ? item.shipName : ""}
                        </h6>
                        {
                          user === userRoles.mmpladmin || user === userRoles.mmpl || user == userRoles.approver ?
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={this.renderShipNotes()}>
                              <img width="25" height="25" data-toggle="modal" data-target=".planning-modal-lg" className="equipment-service-pop-up-trigger" data-shipId={item.shipId} src={note}></img>
                            </OverlayTrigger> : ""

                        }

                      </div>

                      <div
                        className="tip_data col-sm-12 col-lg-7"
                        id="popup-trigger"
                        // data-items={item.shipId}
                        onClick={() => this.setPopup(item.shipId)}
                        // // onMouseDown={() => this.setPopup2()}
                        style={{ cursor: "pointer" }}
                      >
                        <span>
                          <strong>{t("content.Destination")} : </strong>
                          <i aria-hidden="true"></i>
                          <span className="lato">
                            {item.destination ?? "Destination"}
                          </span>
                        </span>
                        <strong> | </strong>
                        <span className={` ${isArabic ? 'arabic_ship' : ''}`}>
                          <strong>{t("content.ETA")}  </strong>
                          <strong>:</strong>
                          <i aria-hidden="true"></i>
                          <span className="lato ">
                            {item.eta
                              ? moment(item.eta).format("DD MMM YYYY")
                              : ""}
                          </span>
                        </span>
                      </div>
                      <div className="col-sm-3 md-12 align-self-start">
                        <span className={`${isArabic ? 'arabic' : ''}`}>
                          <strong>{t("content.TotalEquipment")} </strong>
                          <strong>:</strong>
                          <span className="lato ">
                            {item.total ? item.total : 0}
                          </span>
                        </span>
                      </div>
                      <div
                        className={
                          showMMPLDetailsPane ? "col-sm-6" : "col-sm-3"
                        }
                      >
                        <span className={`${isArabic ? 'arabic' : ''}`}>
                          <strong
                            onClick={() =>
                              this.getShipRemark(item.overDueRemarks)
                            }
                          >
                            {t("content.OverDueEquipment")}{"  "}
                          </strong>
                          <strong>:</strong>

                          <span className="lato ">
                            {item.overDueCount ? item.overDueCount?.total : 0}
                          </span>
                        </span>

                        <div className="row">
                          <div className="col-12">
                            <span className={`${isArabic ? 'arabic' : ''}`}><strong>{t("content.ship")}</strong>
                              <strong>:</strong>
                              {item?.overDueCount?.ship || 0}{" "}
                              <span className={`ship-shore-divider ${isArabic ? 'arabic' : ''}`}><strong>{t("content.shore")}</strong>
                                <strong>:</strong>
                                {item?.overDueCount?.shore || 0}</span>
                            </span>

                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 md-12">
                        <span className={`${isArabic ? 'arabic' : ''}`}>
                          <strong>{t("content.EquipmentDuein30Days")} </strong>
                          <strong>:</strong>
                          <span className="lato ">
                            {item.in30DaysCount ? item.in30DaysCount?.total : 0}
                          </span>
                        </span>
                        <div className="row">
                          <div className="col-12">
                            {" "}
                            <span className={`${isArabic ? 'arabic' : ''}`}><strong>{t("content.ship")}</strong>
                              <strong>:</strong>
                              {item?.in30DaysCount?.ship || 0}{" "}
                              <span className={`ship-shore-divider ${isArabic ? 'arabic' : ''}`}><strong>{t("content.shore")}</strong>
                                <strong>:</strong>
                                {item?.in30DaysCount?.shore || 0}</span>
                            </span>

                          </div>
                        </div>
                      </div>
                      <div className="col-sm-3 md-12">
                        <span className={`${isArabic ? 'arabic' : ''}`}>
                          <strong>{t("content.EquipmentDuein90Days")} </strong>
                          <strong>:</strong>
                          <i aria-hidden="true"></i>
                          <span className="lato ">
                            {item.in90DaysCount ? item.in90DaysCount?.total : 0}
                          </span>
                        </span>
                        <div className="row">
                          <div className="col-12">
                            <span className={`${isArabic ? 'arabic' : ''}`}><strong>{t("content.ship")}</strong>
                              <strong>:</strong>
                              {item?.in90DaysCount?.ship || 0}{" "}
                              <span className={`ship-shore-divider ${isArabic ? 'arabic' : ''}`}><strong>{t("content.shore")}</strong>
                                <strong>:</strong>
                                {item?.in90DaysCount?.shore || 0}</span>
                            </span>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={` alignFlex col-sm-2 col-md-2 col-lg-2 text-center pl-0 ${user === userRoles.mmpladmin ? "" : "align-self-center"
                      }`}
                  >
                    <div className="col-sm-12 px-0 alignMobile">
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.renderbudgetover()}
                      >
                        <MdReport
                          className="px-1 click"
                          style={{
                            color: "rgb(26, 52, 100)",
                            fontSize: "2.4rem",
                            marginTop: "-10px",
                          }}
                          onClick={() => this.gotobudgetscreen(item.shipId)}
                        />
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.renderShipService()}>
                        <FaToolbox
                          className="px-1 click"
                          style={{
                            color: "rgb(26, 52, 100)",
                            fontSize: "2.2rem",
                            marginTop: "-14px",
                          }}
                          onClick={() => this.Gotoservicescreen(item.shipId)}
                        />
                      </OverlayTrigger>

                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.renderPopover()}
                      >
                        <i
                          className="fa fa-download click px-1"
                          aria-hidden="true"
                          style={{ color: " #1a3464", fontSize: "1.5rem" }}
                          onClick={() =>
                            this.downloadDocument(item.shipId, item.shipName, isContract, isBoth)}>
                          {" "}
                        </i>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.renderMoreDetails()}
                      >
                        <i
                          className="fa fa-info-circle click px-1"
                          aria-hidden="true"
                          onClick={() => this.getShipMMPLInfo(item)}
                          style={{ color: " #1a3464", fontSize: "1.8rem" }}
                        ></i>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.renderViewDetails()}
                      >
                        <i
                          className="fa fa-eye click px-1"
                          aria-hidden="true"
                          onClick={() => this.ShowSidePanel(item.shipId)}
                          style={{ color: " #1a3464", fontSize: "1.8rem" }}
                        ></i>
                      </OverlayTrigger>
                    </div>
                    {user === userRoles.mmpladmin && (
                      <div
                        className="col-sm-12 text-center pl-0 py-1"
                        style={{ color: "#fff" }}
                        //width:auto
                      >
                        <button
                          className="btn btn-secondary btn-xs btn-conf-edit customBtnMargin"
                          id={`popover${index}`}
                          style={{
                            width: `${this.state.isMobile ? "175px" : ""}`,
                            // marginLeft:'1.1em'
                          }}
                        >
                          <i className="glyphicon glyphicon-remove"></i>{" "}
                          {t("content.Generate")}
                          <br /> {t("content.Servicerequest")}
                        </button>
                        <Popover
                          placement="left"
                          trigger="legacy"
                          isOpen={this.state[`popover${index}`]}
                          target={`popover${index}`}
                          toggle={() => this.toggle(`popover${index}`, item)}
                        >
                          <PopoverHeader>
                            {t("content.Generate")} {t("content.Servicerequest")}
                          </PopoverHeader>
                          <PopoverBody>
                            <div className="row">
                              <div className="col-4 my-1">
                                <input
                                  type="radio"
                                  name="ship"
                                  checked={this.state.isShip}
                                  onChange={(e) =>
                                    this.handleRadioButtonChange(e)
                                  }
                                />
                                <span className="ml-1">{t("Generateservicerequestcontent.Ship")}</span>
                              </div>
                              <div className="col-4 my-1">
                                <input
                                  type="radio"
                                  name="shore"
                                  checked={this.state.isShore}
                                  onChange={(e) =>
                                    this.handleRadioButtonChange(e)
                                  }
                                />
                                <span className="ml-1">{t("Generateservicerequestcontent.Shore")}</span>
                              </div>
                              <div className="col-4 my-1">
                                <input
                                  type="radio"
                                  name="both"
                                  checked={this.state.isBoth}
                                  onChange={(e) =>
                                    this.handleRadioButtonChange(e)
                                  }
                                />
                                <span className="ml-1">{t("Generateservicerequestcontent.Both")}</span>
                              </div>
                              <div
                                className="col-12 mt-1"
                                style={{ textAlign: "right" }}
                              >
                                <div className="btn-group">
                                  <Button
                                    className="btn btn-primary btn-xs mt-2"
                                    size="sm"
                                    onClick={() => this.submitRequest(item, isContract, isBoth)}
                                  >
                                    {t("Generateservicerequestcontent.Request")} {""} {t("Generateservicerequestcontent.Ship")}
                                  </Button>
                                </div>
                              </div>
                            </div>
                          </PopoverBody>
                        </Popover>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })
      : null;
  };

  downloadDocument(shipId, shipName, contract, both) {
    const { dispatch } = this.props;
    dispatch(downloadShipEquipmentStatus(shipId, shipName, contract, both));
  }

  submitRequest = (item, contract, both) => {
    const { dispatch } = this.props;
    dispatch(downloadServiceRequest(item, this.state, contract, both));
  };
  gotobudgetscreen = (shipId) => {
    this.props.history.push(`/Home/BudgetListEdit/${shipId}`);
  };
  Gotoservicescreen = (shipId) => {
    this.props.history.push(`/Home/ServiceUpdateList/${shipId}`);
  };

  ShowSidePanel = (shipId) => {
    this.props.dispatch({
      type: "MDSearchIsTrue",
      data: {},
    });
    // this.props.dispatch({ type: "ShowMMPLDetails", data: true });
    this.props.dispatch({ type: "ShowEquipmentDetails", data: false });
    // this.props.history.push(`/Home/MMPLDashboard/EquipmentDetail/${id}`);
    this.props.dispatch({ type: "IsServiceUpdate", data: false });
    this.props.dispatch({ type: "ShowShipDetails", data: true });
    this.props.dispatch({ type: "Shipment Library", data: false });
    this.props.history.push(`/Home/ShipDetails/${shipId}`);
  };

  setPopup = (shipId) => {
    this.props.dispatch({ type: "MapPopup", data: shipId });
  };
  // setPopup2 = () => {
  //   this.props.dispatch({ type: "MapPopup", data: 0 });
  // };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    showMMPLDetailsPane: state.SidePanReducer.ShowMMPLDetails || false,
    isServiceDetail: state.ServiceUpdateReducer.IsServiceUpdate || false,
    MMPLShipInfo: state.MMPLDashboardReducer.MMPLShipInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MMPLShipCard))
);
